var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "399px",
    height: "156px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "rgba(0, 0, 0, 0)",
    d: "M -0.5,-0.5 C 132.5,-0.5 265.5,-0.5 398.5,-0.5C 398.5,51.5 398.5,103.5 398.5,155.5C 265.5,155.5 132.5,155.5 -0.5,155.5C -0.5,119.5 -0.5,83.5 -0.5,47.5C 1.03308,49.3548 2.69974,51.1881 4.5,53C 5.44802,53.4828 6.44802,53.6495 7.5,53.5C 8.13816,61.5994 8.80483,69.5994 9.5,77.5C 21.3171,86.2492 32.9838,95.2492 44.5,104.5C 45.6648,112.145 45.8315,119.812 45,127.5C 35.696,131.448 33.0293,138.115 37,147.5C 44.2579,155.432 51.5913,155.432 59,147.5C 62.9315,138.438 60.4315,132.105 51.5,128.5C 50.1667,120.5 50.1667,112.5 51.5,104.5C 62.9093,95.3793 74.4093,86.3793 86,77.5C 86.3333,69.8333 86.6667,62.1667 87,54.5C 94.9094,51.5784 98.2427,45.9118 97,37.5C 92.3142,28.7163 85.4809,26.5497 76.5,31C 70.4451,37.0564 69.9451,43.5564 75,50.5C 76.2635,52.607 78.0968,53.607 80.5,53.5C 81.4621,60.4122 81.7955,67.4122 81.5,74.5C 71.2086,82.2856 61.0419,90.2856 51,98.5C 50.5003,90.5069 50.3336,82.5069 50.5,74.5C 54.9115,73.9299 58.0782,71.5966 60,67.5C 62.3879,57.2239 58.3879,51.2239 48,49.5C 37.6121,51.2239 33.6121,57.2239 36,67.5C 38.0565,71.2229 41.0565,73.8896 45,75.5C 45.6667,83.1667 45.6667,90.8333 45,98.5C 35,90.5 25,82.5 15,74.5C 14.5004,67.5079 14.3337,60.5079 14.5,53.5C 18.5616,53.2759 21.395,51.2759 23,47.5C 26.3393,36.5094 22.3393,30.176 11,28.5C 5.9273,28.9465 2.09397,31.2798 -0.5,35.5C -0.5,23.5 -0.5,11.5 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b75a0",
    d: "M 168.5,29.5 C 161.5,29.5 154.5,29.5 147.5,29.5C 147.5,55.5 147.5,81.5 147.5,107.5C 146.502,81.3386 146.169,55.0053 146.5,28.5C 154.019,28.175 161.352,28.5084 168.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a266a",
    d: "M 211.5,153.5 C 209.541,147.25 208.874,140.584 209.5,133.5C 222.394,128.748 229.227,119.415 230,105.5C 230.5,79.8355 230.667,54.1688 230.5,28.5C 237.5,28.5 244.5,28.5 251.5,28.5C 251.667,56.1687 251.5,83.8353 251,111.5C 247.867,135.128 234.7,149.128 211.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b286b",
    d: "M 273.5,29.5 C 281.343,28.1796 289.343,28.1796 297.5,29.5C 313.817,70.4475 329.15,111.781 343.5,153.5C 335.275,154.815 327.108,154.815 319,153.5C 304.296,111.876 289.129,70.5428 273.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4b276b",
    d: "M 371.5,28.5 C 379.174,28.3336 386.841,28.5003 394.5,29C 381.204,61.0947 368.037,93.2614 355,125.5C 351.265,115.461 347.431,105.461 343.5,95.5C 352.841,73.1377 362.174,50.8043 371.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#824e8b",
    d: "M 81.5,74.5 C 82.1652,71.1833 82.4986,67.6833 82.5,64C 82.4877,60.0982 81.821,56.5982 80.5,53.5C 78.0968,53.607 76.2635,52.607 75,50.5C 69.9451,43.5564 70.4451,37.0564 76.5,31C 85.4809,26.5497 92.3142,28.7163 97,37.5C 98.2427,45.9118 94.9094,51.5784 87,54.5C 86.6667,62.1667 86.3333,69.8333 86,77.5C 74.4093,86.3793 62.9093,95.3793 51.5,104.5C 50.1667,112.5 50.1667,120.5 51.5,128.5C 60.4315,132.105 62.9315,138.438 59,147.5C 51.5913,155.432 44.2579,155.432 37,147.5C 33.0293,138.115 35.696,131.448 45,127.5C 45.8315,119.812 45.6648,112.145 44.5,104.5C 32.9838,95.2492 21.3171,86.2492 9.5,77.5C 10.1335,69.0968 9.46684,61.0968 7.5,53.5C 6.44802,53.6495 5.44802,53.4828 4.5,53C 2.69974,51.1881 1.03308,49.3548 -0.5,47.5C -0.5,43.5 -0.5,39.5 -0.5,35.5C 2.09397,31.2798 5.9273,28.9465 11,28.5C 22.3393,30.176 26.3393,36.5094 23,47.5C 21.395,51.2759 18.5616,53.2759 14.5,53.5C 14.3337,60.5079 14.5004,67.5079 15,74.5C 25,82.5 35,90.5 45,98.5C 45.6667,90.8333 45.6667,83.1667 45,75.5C 41.0565,73.8896 38.0565,71.2229 36,67.5C 33.6121,57.2239 37.6121,51.2239 48,49.5C 58.3879,51.2239 62.3879,57.2239 60,67.5C 58.0782,71.5966 54.9115,73.9299 50.5,74.5C 50.3336,82.5069 50.5003,90.5069 51,98.5C 61.0419,90.2856 71.2086,82.2856 81.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a266a",
    d: "M 168.5,29.5 C 168.333,56.1687 168.5,82.8354 169,109.5C 171.036,121.293 177.536,129.293 188.5,133.5C 188.5,140.167 188.5,146.833 188.5,153.5C 187.167,153.5 185.833,153.5 184.5,153.5C 166.369,148.871 154.535,137.538 149,119.5C 148.499,115.49 147.999,111.49 147.5,107.5C 147.5,81.5 147.5,55.5 147.5,29.5C 154.5,29.5 161.5,29.5 168.5,29.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1f6",
    d: "M 8.5,33.5 C 16.3204,33.152 19.8204,36.8186 19,44.5C 14,51.1667 9,51.1667 4,44.5C 3.33333,42.5 3.33333,40.5 4,38.5C 5.36569,36.6383 6.86569,34.9717 8.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1f6",
    d: "M 81.5,33.5 C 89.3204,33.152 92.8204,36.8186 92,44.5C 87,51.1667 82,51.1667 77,44.5C 76.3333,42.5 76.3333,40.5 77,38.5C 78.3657,36.6383 79.8657,34.9717 81.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bea2c2",
    d: "M 7.5,53.5 C 9.46684,61.0968 10.1335,69.0968 9.5,77.5C 8.80483,69.5994 8.13816,61.5994 7.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bda1c1",
    d: "M 80.5,53.5 C 81.821,56.5982 82.4877,60.0982 82.5,64C 82.4986,67.6833 82.1652,71.1833 81.5,74.5C 81.7955,67.4122 81.4621,60.4122 80.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#785d8f",
    d: "M 188.5,133.5 C 189.491,140.313 189.825,147.313 189.5,154.5C 187.585,154.784 185.919,154.451 184.5,153.5C 185.833,153.5 187.167,153.5 188.5,153.5C 188.5,146.833 188.5,140.167 188.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cec4d7",
    d: "M 209.5,133.5 C 208.874,140.584 209.541,147.25 211.5,153.5C 210.791,154.404 209.791,154.737 208.5,154.5C 208.175,147.313 208.509,140.313 209.5,133.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.001ff9db4aefe0d4c13a5d555e523157.svg";
export { ForwardRef as ReactComponent };